import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';
import SalesOrdersTable from 'components/SalesOrders/SalesOrdersTable';
import SalesOrderInvoice from 'components/Invoices/SalesOrderInvoice';

import { clearNewSO } from 'redux/actions';
import { admin } from 'variables/userAccountTypes';

const mapStateToProps = (state) => ({
  newSalesOrder: state.newSalesOrder
});

const SalesOrderListResults = (props) => {

  const printRef = useRef();

  const { displayId, customerId, soProducts, totalVat, total, paymentMethod } = props.newSalesOrder;
  
  const [userTabValue, setUserTabValue] = useState(0);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Sales Order Invoice"
  });
  
  const handleUserTabChange = (event, newValue) => {
    setUserTabValue(newValue);
  };
  
  const salesOrderCleanup = () => {
    props.clearNewSO();
    setOpenInvoiceModal(false);
  };
  
  const createInvoiceInfo = () => {
    const customerInfo = props.customers.find(customer => customer.id === customerId);
    return {
      displayId,
      customerName: customerInfo ? customerInfo.name : "",
      customerPhone: customerInfo ? customerInfo.phone : "",
      paymentDate: new Date(),
      subTotal: total - totalVat,
      taxTotal: totalVat,
      grandTotal: total,
      paymentMethod,
      products: soProducts
    }
  };
  
  return (
    <React.Fragment>
      { props.activeUserType === admin ?
        <Box>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            <Paper>
              <Tabs
                value={userTabValue}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleUserTabChange}
                centered
              >
                {props.user.standard_users.map((user) => (<Tab key={user.id} label={user.name} />))}
              </Tabs>
            </Paper>
          </Box>
          <Box marginTop={1}>
            <SalesOrdersTable
              userTabValue={userTabValue}
              activeUserType={props.activeUserType}
              salesOrders={props.salesOrders}
              customers={props.customers}
              products={props.products}
              user={props.user}
            />
          </Box>
        </Box> :
        <SalesOrdersTable
          activeUserType={props.activeUserType}
          salesOrders={props.salesOrders}
          customers={props.customers}
          products={props.products}
          user={props.user}
          setOpenInvoiceModal={setOpenInvoiceModal}
        />
      }
      { openInvoiceModal ?
      <Modal open={openInvoiceModal}>
        <Card>
          <CardHeader
            subheader="Please Review the Order."
            title="Print Invoice"
          />
          <Divider />
          <CardContent>
            <Box>
              <Paper
                style={{
                  overflow: 'auto',
                  maxHeight: 469
                }}
              >
                <SalesOrderInvoice
                  ref={printRef}
                  info={createInvoiceInfo()}
                  user={props.user}
                />
              </Paper>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '1%'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handlePrint}
                >
                  Print Invoice
                </Button>
                <Button
                  color="primary"
                  onClick={salesOrderCleanup}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </CardContent>
          <Divider />
        </Card>
      </Modal> : null }
    </React.Fragment>
  )
};

export default connect (mapStateToProps, {clearNewSO}) (SalesOrderListResults);